import React, {
    PureComponent
} from 'react';
import PropTypes from 'prop-types';
import './Icon.less';

const ICON_NAME_PREFIX = 'Icon_';

export const ICON_TYPE = {
    CRITICAL: 'critical',
    PAYPAL_LOGO: 'pp-logo',
    PAYPAL_CREDIT_LOGO: 'ppc-logo',
    PAYPAL_RATENZAHLUNG: 'pp-ratenzahlung-logo',
    PDF: 'pdf', //TODO: Replace all usages of .download_icon
    PRINT: 'print' //TODO: Replace all usages of .print_icon
};

export default class Icon extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        type: PropTypes.oneOf(Object.values(ICON_TYPE)).isRequired
    };

    static defaultProps = {
        className: ''
    };

    render() {
        const { type, className, ...rest } = this.props;
        const wrapperClasses = [
            'Icon',
            `${ICON_NAME_PREFIX}${type}`,
            className
        ];

        return (
            <i
                className={wrapperClasses.join(' ')}
                {...rest}
            />
        );
    }
}
